import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActionParameterDefinitionDTO, ActionResultDTO, CompanyDocDTO, ContractDTO } from '../../../api/plyca-dtos-v2';
import { DocumentDTO, RelatedDocumentDTO, getSimpleIdentifierFromString, LinkedActionsDTO, ActionDTO, TaskDTO } from '../../../api/plyca-dtos';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../baseFormComponent/baseForm.component';
import { EndorsementDTO, EndorsementInvoiceDTO } from '../model/endorsement.model';
import { AccountingDocumentModel } from '../../../dossiers/accounting/accountingDocument.component';
import { FormConfig } from '../../../components/forms/form.objects';
import { SearchSettingDTOModal, searchGenericComponent } from '../../../components/search/searchGeneric.component';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { map, catchError, finalize, take, tap, switchMap, mergeMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { PlycaErrorHandler } from '../../../../http/PlycaErrorHandler';
import { throwError, forkJoin, Observable, of, EMPTY, from, concat } from 'rxjs';
import { UserService } from '../../../user.service';
import { ServiceLocator } from '../../../ServiceLocator';

export class EndorsementModel {
  dto: EndorsementDTO;
  ui: {
    edition?: boolean;
    isModeError?: boolean;
    expenseDocumentSign?: string;
  };
}

@Component({
  templateUrl: '../../baseFormComponent/baseForm.template.html'
  //templateUrl: '../../../dossiers/registerContractModifications/registerContractModification.template.html'
})
export class EndorsementComponent extends BaseFormComponent<EndorsementDTO, EndorsementModel> implements OnInit, OnDestroy {
  public translationService: TranslateService;
  private plycaErrorHandler: PlycaErrorHandler;
  private userService: UserService;
  private initialChargeExistsEndorsement = false;
  constructor(elem: ElementRef) {
    super(elem);
    this.userService = ServiceLocator.injector.get(UserService);

  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  getFormSettingURL(): string {
    return 'endorsement/endorsementSettings.json';
  }
  getObjectIdentifier() {
    return undefined;
  }
  dtoToModel(dto: EndorsementDTO): Observable<EndorsementModel> {
    let model = new EndorsementModel();
    model.dto = this.task.work['endorsement'];
    model.ui = {
      edition: true,
      isModeError: false,
    };
    this.initialChargeExistsEndorsement = this.existsEndorsement(model.dto.endorsementInvoices);
    if (model.dto.expenseDocument.expenseDocumentType?.sign === 0) {
      if (model.dto.expenseDocument.expenseDocumentType.multipleSign) {
        model.ui.expenseDocumentSign = '+/-';
      } else {
        model.ui.expenseDocumentSign = '+';
      }
    } else if (model.dto.expenseDocument.expenseDocumentType?.sign === 1) {
      model.ui.expenseDocumentSign = '-';
    }

    /*if (this.task && this.task.work) {
      if (model.dto.document && model.dto.document.relatedDocuments) {
        let relatedDocuments = model.dto.document.relatedDocuments;
        for (let i in relatedDocuments) {
          if (relatedDocuments[i]) {
            if (relatedDocuments[i].visible) {
              model.ui.visibleRelatedReceipts.push(relatedDocuments[i]);
            } else {
              model.ui.notVisibleRelatedReceipts.push(relatedDocuments[i]);
            }
          }
        }
      }

    }*/
    return of(model);
  }

  // modelToDTO: Lo usa el insert update del entity!!
  modelToDTO(model: EndorsementModel): EndorsementDTO {
    // Antes de enviar a servidor

    /*if (model.dto.endorsementInvoices) {
      model.dto.endorsementInvoices = JSON.parse(
        JSON.stringify(model.dto.endorsementInvoices, (k, v) => (k === '_parent' ? undefined : v))
      );
    }*/

    let cleanModel = JSON.parse(
      JSON.stringify(model.dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    // ************************************************************************************************************************
    //  Por el tipo de servicio qque es REACTIVO, hacemos esto para que el work se entere mediane el doOnResourceChange!!
    //************************************************************************************************************************* */

    //let newTask: TaskDTO =  new TaskDTO(); // NO SE PUEDE HACER PORQUE ES UN INTERFAZ!!
    //let taskAux = {} as TaskDTO;
    /* let taskAux = new Object() as TaskDTO;
     taskAux.identifier = this.task.identifier;
     cleanModel.task = taskAux;*/
    // cleanModel es un nuevo objeto!!
    return cleanModel;
  }
  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Endorsement.detail.title';
    headerInfo.titleIcon = 'fas fa-hand-holding';
    headerInfo.project = this.model.dto.division.project;
    return headerInfo;
  }

  getServiceURL(): string {
    return this.configuration.ENDORSEMENT_DOCUMENT_SERVICE_URL;
  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.accept',
        'fas fa-lg fa-check',
        'btn-primary',
        true,
        this.windowHash
      ),
      success => {
        if (this.existsEndorsement(this.model.dto.endorsementInvoices)) {
          this.saveAndConfirmationIntegration();
        } else {
          this.deleteAndConfirmationIntegration();
        }
      });
    /*this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'Service.save',
        //'save - plycaService.update',
        'fas fa-save',
        'btn-primary',
        true,
        this.windowHash
      ),
      () => {
        this.waitService.startWaiting();
        this.subscribe(this.save(false),
          () => {
            //this.ref.close(this.model);
            this.uiService.routeBack();
          },
          (error: any) => {
            this.waitService.cancelWaiting();
          }
        );
      });*/
    this.headerActionsService.addDivider();
    this.addBackAction();
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.functions.push({
      identifier: 'openNitSearch',
      fn: this.openNitSearch
    });
    formConfig.functions.push({
      identifier: 'cleanNit',
      fn: this.cleanNit
    });

    return of(formConfig);
  }
  public cleanNit(model: any, changes?: any) {
    let endorsementInvoice: EndorsementInvoiceDTO = model;
    endorsementInvoice.nit = null;
    endorsementInvoice.description = null;
    endorsementInvoice.ordinalBank = null;
    endorsementInvoice.bankType = null;
  }

  public openNitSearch(model: any, changes?: any) {

    let endorsementInvoice: EndorsementInvoiceDTO = model;
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'NIT';
    param1.value = model._parent.dto.expenseDocument.interested.externalIdentifier;
    parametersURL.push(param1);

    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'SOCIEDAD';
    param2.value = getSimpleIdentifierFromString(model._parent.dto.expenseDocument.society.identifier);
    parametersURL.push(param2);

    let completedResult = true;
    let autoSearch = true;
    let contextSearch = new SearchSettingDTOModal(
      'INTEGRATIONENDOSOS',
      autoSearch,
      parametersURL,
      completedResult
    );

    let config: DynamicDialogConfig = {
      header: 'Buscador de endosos en el sistema contable',
      width: '70%',
      style: { 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    config['showWait'] = true;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(
      ref.onClose.pipe(
        tap((result: CompanyDocDTO) => {
          if (result) {
            endorsementInvoice.nit = result.externalIdentifier;
            endorsementInvoice.description = result.name;
            endorsementInvoice.ordinalBank = result.ordinalBank;
            endorsementInvoice.bankType = result.bankType;
          } else {
            console.log('Cerrado sin seleccionar');
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );
  }

  private saveAndConfirmationIntegration(): void {
    this.subscribe(this.save(true).
      pipe(
        tap(
          (endorsement: EndorsementDTO) => {
            this.model.dto = endorsement;
            this.task.work['endorsement'] = endorsement;
          }),
        tap(() => {
          let processTaskObservable = true;
          this.integrationSAP(processTaskObservable);
        }),
        catchError((error: any) => { // catch del pipe!!
          this.waitService.cancelWaiting();
          return throwError(error);
        })
      )
    )
  }

  private existsEndorsement(endorsementInvoices: Array<EndorsementInvoiceDTO>): boolean {
    // Comprobamos si hay endosos, para ello debemos verificar que al menos tenemos un endosos con el NIT informado
    let existsEndorsement = false;
    if (endorsementInvoices) { // Comunicado a SAP
      //let endorsementInvoices: Array<EndorsementInvoiceDTO> = this.model.dto.endorsementInvoices;
      for (let i in endorsementInvoices) {
        if (endorsementInvoices[i]) {
          if (endorsementInvoices[i].nit) {
            existsEndorsement = true;
            break;
          }
        }
      }
    }
    return existsEndorsement;
  }

  private deleteAndConfirmationIntegration() {
    this.confirmationService.confirm({
      message: this.translateService.instant('No se ha dado de alta ningún Endosatario para las facturas de este documento. ¿Desea continuar y despachar la tarea?'),
      acceptLabel: this.translateService.instant('General.yes'),
      rejectLabel: this.translateService.instant('General.no'),
      accept: () => {
        if (this.initialChargeExistsEndorsement) {
          this.subscribe(this.delete(true). // Borramos la ficha de endoso (AYMAD_FICHAENDOSO) y los endosos correspondientes (AYMAD_FACTURA_FICHAENDOSO)
            pipe(
              tap(() => {
                if (this.model.dto.document.currentState.identifier === '1') { // Comunicar a SAP y Mantener/Despechar
                  let processTaskObservable = true;
                  this.integrationSAP(true);
                } else {
                  this.processTask(); // Mantener/Despechar (No se comunica a SAP)
                }
              }),
              catchError((error: any) => { //catch del pipe!!
                //this.waitService.cancelWaiting();
                //this.errorHandler.showServerError(error)
                return throwError(error);
              })
            )
          );
        } else {
          //console.log('******************************************** Despachar tarea *************************************************************');
          this.processTask();
        }
      },
      reject: () => {
        // No hacemos nada!!
        //this.salir();
      }
    })
  }

  private integrationSAP(processTaskObservable: boolean): void {
    this.confirmationService.confirm({
      message: this.translateService.instant('¿Desea mandar la información generada en esta tarea a SAP para actualizar los datos?'),
      acceptLabel: this.translateService.instant('General.yes'),
      rejectLabel: this.translateService.instant('General.no'),
      accept: () => {
        this.waitService.startWaiting('Sincronizando con SAP...');
        this.subscribe(
          this.plycaService.getAvailableAction('ENDORSEMENT_EXPENSEDOCUMENT_INTEGRATION_RECORD', this.model.dto.expenseDocument.identifier, 'EXPENSEDOCUMENT')
            .pipe(// Si 404 catchError()
              /*tap(
                (actions: LinkedActionsDTO) => {
                  console.log('******************************************** next getAvailableActions');
                  if (actions && actions.actions) {
                  }
                }
              ),
              catchError((error: any) => {
                this.plycaErrorHandler.showServerError(error);
                return throwError(error);
              }),
              finalize(
                () => {

                })
            */
              mergeMap(
                (availableActions: any) => {
                  if (availableActions) { // 200 OK

                    return this.processAvailableActions(availableActions);
                  } else { // 204
                    //return of({}); // Permite ir al siguiente merge!!
                    let showContentRef = this.errorHandler.showServerError('La acción encargada de registrar el endoso en el sistema contable no está disponible para este endoso cuyo indentificador es: [' + this.model.dto.identifier + ']');
                    return showContentRef.onClose.pipe(
                      tap(() => {
                        this.validaCierreVentana = false; // Para que no se muestre el mensaje: ¿Descartar cambios?
                        this.salir();
                      })
                    );
                  }
                }
              ),
              mergeMap((actionResult: ActionResultDTO) => {
                this.waitService.cancelWaiting();
                if (actionResult !== undefined) { // processExpenseDocument return of(undefined) cuando no es un documento contable o lo es pero no forma parte de la tarea
                  let message: string;
                  let errorStyle = false;

                  if (actionResult.identifier === 'OK') {
                    if (actionResult.objectResult) {
                      errorStyle = true;
                      message = '<li>' + actionResult.objectResult
                        ? '\n' + JSON.stringify(actionResult.objectResult)
                        : '';
                    } else {
                      message = '<li>' + this.translate.instant('Actions.exec.ok');
                    }
                  } else {
                    // Ejemplo de lo que recibimos:

                    //{identifier: "NOK",…}
                    // description: "Error al registrar el endoso en el sistema contable, para el documento de fase O con número de captura: [49768145-CLASE-2022]<br> Causa: <ul><li>Registro de endosos en el sistema contable: No se ha recibido respuesta del servidor. Error de time-out. Inténtelo más tarde.</ul>"
                    // identifier: "NOK"
                    errorStyle = true;
                    message = this.translate.instant('General.errorMessage');
                    if (actionResult.description) {
                      message = actionResult.description;
                    }
                    message = '<li>' + message;
                  }

                  let titleKey = 'Sincronización con SAP';
                  let styleClass: string;
                  if (errorStyle) {
                    styleClass = 'errorStyle';
                  } else {
                    styleClass = 'successStyle';
                  }
                  let finalMessage = '<ul>' + message + '</ul>';
                  this.waitService.cancelWaiting();
                  let showContentRef = this.uiService.showContent(finalMessage, titleKey, styleClass);
                  return showContentRef.onClose.pipe(
                    map(() => {
                      if (errorStyle) {
                        return false;
                      } else {
                        return processTaskObservable;
                      }
                    })
                    /*tap(() => {
                      processTaskObservable = false;
                      //if (!this.processedTask) {
                      //  this.waitService.startWaiting(this.translateService.instant('General.infoUpdate'));
                      //}
                    })*/
                  );
                }
              }),
              mergeMap(
                (process: boolean) => {
                  if (process) {
                    return this.processTaskObservable();
                  }
                }
              )
              //}*/
            )
        );
      },
      reject: () => {
        this.validaCierreVentana = false;
        // Importante ***********************************************************************************************************************
        //    - this.uiService.routeBack() termina invocando a TaskHandler.canDeactivate
        //    - No es necesario hacer un savework porque es reactivo!!, el work reacciona
        //      a los documentos contables (insert, update..)
        // ***********************************************************************************************************************************
        this.salir();
      }
    });
  }

  private processAvailableActions(availableActions: any): Observable<ActionResultDTO> {
    let actionResultError = new ActionResultDTO();
    if (availableActions?.actions) {
      if (availableActions.actions?.length === 1) {
        let actions: ActionDTO[] = availableActions.actions;
        let actionReturnObs: Observable<ActionResultDTO>
        actionReturnObs = this.plycaService.runActionLink(actions[0]);
        return actionReturnObs;
      } else {
        actionResultError.description = 'Hay más de una acción disponibles, por este motivo, no se informa a SAP';
      }
    }
    actionResultError.identifier = 'KO';
    actionResultError.description = 'No hay acciones disponibles, por este motivo, no se informa a SAP';
    return of(actionResultError);
  }


  // No es necesario en este servicio ya que el savework no graba el objeto de negocio, si como buenas prácticas
  protected getTask(): TaskDTO {
    //let taskAux = lodash.cloneDeep(this.task);
    let taskAux = JSON.parse(
      JSON.stringify(this.task, (k, v) =>
        k === '_parent' ? undefined : v
      )
    );
    // modelToDto crea un nuevo objeto por ese motivo no hago lodash.cloneDeep(this.model)
    let dto = this.modelToDTO(this.model);
    taskAux.work.endorsement = dto;
    return taskAux;
  }


  // Sobreescribir para que el model.dto.work se entere del updatedTask

  // Método de TaskHandler!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  /*  saveWorkObservable(reactivate = false): Observable<any> {
      this.waitService.startWaiting();
      return this.taskService.saveWork(this.getTask(), reactivate).pipe(
        tap((updatedTask: TaskDTO) => {

          // Copio propiedades
          this.formService.merge(this.task, updatedTask);
          // Asigno ariables !! Esto es un problema ya que en nuestra clase model.dto = this.task.work['endorsement'];
          // this.task = updatedTask;

        }),
        catchError(err => {
          if (this.formPlycaRef && this.formService.isValidationResponse(err)) {
            this.manageActionError(err, true, false);
          } else {
            this.waitService.cancelWaiting();
            this.errorHandler.showServerError(err);
          }
          return throwError(err);
        })
      );
    }*/


}
